'use strict';

var collapsibleItem = require('base/components/collapsibleItem');

function collapsible () {
    var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];
    sizes.forEach(function (size) {
    var selector = '.collapsible-' + size + ' .title';
        $('body').on('click', selector, function (e) {
            $('.footer-item').not(':eq(' + $(this).closest('.footer-item').index() + ')').removeClass('active');
        });
    });
};


module.exports = {
    collapsibleItem: collapsible
};